import { features } from './lib/environments/feature-flags.default';

export const SBSA_FEATURES = features;
